import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getTranslations } from '@translations';
import { Button, Icon } from '@components';

import { useHeaderContext } from '../../../../HeaderContext';

import styles from './styles/index.module.scss';

const Basket = ({ isB2B, count, className }) => {
  const translations = getTranslations();
  const { platformBaseUrl } = useHeaderContext();
  const url = translations('header.menu.basket.url');
  const basketCountClassName = cn({
    [styles.basketCountB2b]: isB2B,
    [styles.basketCount]: !isB2B,
  });

  return (
    <Button
      color="transparent"
      className={cn(className, styles.basketTab, styles.basketSideMargin)}
      tag="a"
      type="icon"
      href={`${platformBaseUrl}${url}`}
    >
      <Icon isB2B={isB2B} size="24" id="basket" className={styles.basketIcon}>
        <span className={basketCountClassName}>{count}</span>
      </Icon>
      <span className={styles.basketText}>
        {translations('header.menu.basket')}
      </span>
    </Button>
  );
};

Basket.propTypes = {
  isB2B: PropTypes.bool,
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
};

Basket.defaultProps = {
  isB2B: false,
  className: null,
};

export default Basket;
